import * as actionTypes from '../actions/allActionList';

const initialState = {
  classroomDetails: null,
  creatingClassroom: false,
  creatingClassroomDone: false,
  createClassroomError: null,

  fetchingClassroomDetails: false,
  fetchedStatuses: null,
  failedToJoinError: null,

  forceStartClassroomStarted: false,
  forceStartClassroomDone: false,
  forceStartClassroomFailed: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.JOINED_CLASSROOM:
      return {
        ...state,
        classroomDetails: action.classroom,
      };
    case actionTypes.FAILED_TO_JOIN_CLASSROOM:
      return {
        ...state,
        failedToJoinError: action.error,
      };
    case actionTypes.RESET_FAILED_ERROR_JOINING:
      return {
        ...state,
        failedToJoinError: null,
      };
    case actionTypes.FETCHED_SPECIFIC_CLASSROOM:
      return {
        ...state,
        classroomDetails: action.classroom,
      };
    case actionTypes.FAILED_TO_FETCH_SPECIFIC_CLASSROOM:
      return state;
    case actionTypes.CREATE_CLASSROOM_STARTED:
      return {
        ...state,
        creatingClassroom: true,
        creatingClassroomDone: false,
        createClassroomError: null,
      };
    case actionTypes.CREATED_CLASSROOM:
      return {
        ...state,
        classroomDetails: action.classroom,
        creatingClassroom: false,
        creatingClassroomDone: true,
      };
    case actionTypes.FAILED_TO_CREATE_CLASSROOM:
      return {
        ...state,
        createClassroomError: action.error,
        creatingClassroom: false,
        creatingClassroomDone: true,
      };
    case actionTypes.RESET_CLASSROOM_CREATING_STATES:
      return {
        ...state,
        creatingClassroom: false,
        creatingClassroomDone: false,
        createClassroomError: false,
      };
    case actionTypes.FETCHING_CLASSROOM_STATUSES:
      return {
        ...state,
        fetchingClassroomDetails: true,
        fetchedStatuses: null,
      };
    case actionTypes.FETCHED_CLASSROOM_STATUSES:
      return {
        ...state,
        fetchingClassroomDetails: false,
        fetchedStatuses: action.statuses,
      };
    case actionTypes.FORCE_START_CLASSROOM:
      return {
        ...state,
        forceStartClassroomStarted: true,
        forceStartClassroomDone: false,
        forceStartClassroomFailed: false,
      };
    case actionTypes.FAILED_FORCE_START_CLASSROOM:
      return {
        ...state,
        forceStartClassroomStarted: false,
        forceStartClassroomDone: true,
        forceStartClassroomFailed: true,
      };
    case actionTypes.DONE_FORCE_START_CLASSROOM:
      return {
        ...state,
        forceStartClassroomStarted: false,
        forceStartClassroomDone: true,
      };
    default:
      return state;
  }
};

export default reducer;
